import React from "react";
import { IconButton } from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const PasswordVisibility = ({ showPassword, setShowPassword }) => {
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  return (
    <IconButton onClick={togglePasswordVisibility}>
      {showPassword ? (
        <VisibilityOutlinedIcon />
      ) : (
        <VisibilityOffOutlinedIcon />
      )}
    </IconButton>
  );
};

export default PasswordVisibility;
